var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-tabs-wrapper",style:({..._vm.cssStyle, '--active-color': _vm.color})},_vm._l((_vm.showList),function(item,idx){return _c('div',{key:idx,class:['z-tabs-item', idx === _vm.current && 'active'],on:{"click":function($event){return _vm.handleSelect(idx)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }